import state from './vehicle-groups.state'
import mutations from './vehicle-groups.mutations'
import actions from './vehicle-groups.actions'
import getters from './vehicle-groups.getters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
